/*
* Pipeline Theme - Custom JavaScript
*
* Use this file to add custom Javascript to Pipeline. Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

console.log('--- CUSTOM.JS IS RUNNING ON THIS PAGE --- Timestamp: ' + new Date().toLocaleTimeString());

(function() {
  'use strict';
  
  // ============================================
  // SECTION 1: LANDING PAGE DETECTION & HEADER VISIBILITY
  // ============================================
  (function() {
    // IMMEDIATELY show header as soon as possible (don't wait for DOMContentLoaded)
    if (document.body) {
      document.body.classList.add('show-secondary-content');
      console.log('IMMEDIATE: Added show-secondary-content to body');
    }
    
    // Helper functions for template detection
    function isLandingPageTemplate() {
      try {
        const bodyClasses = document.body.className;
        return bodyClasses.includes('landing-page');
      } catch (error) {
        console.error('Error checking landing page template:', error);
        return false;
      }
    }

    function isLoadSecondaryContentTemplate() {
      try {
        const bodyClasses = document.body.className;
        return bodyClasses.includes('load-secondary-content');
      } catch (error) {
        console.error('Error checking load-secondary-content template:', error);
        return false;
      }
    }
    
    // Main landing page detection logic
    document.addEventListener('DOMContentLoaded', function() {
      console.log('Landing Page Detection: DOMContentLoaded fired');
      
      // Make sure the class is still there
      if (!document.body.classList.contains('show-secondary-content')) {
        document.body.classList.add('show-secondary-content');
        console.log('RE-ADDED show-secondary-content class in DOMContentLoaded');
      }
      
      try {
        // Only REMOVE the class if we're certain it's a landing page
        let isLandingPage = false;
        
        // Check window._template
        if (window._template && typeof window._template.suffix === 'string') {
          console.log('Template suffix found:', window._template.suffix);
          
          if (window._template.suffix.toLowerCase().includes('landing-page')) {
            isLandingPage = true;
            console.log('This IS a landing page - removing show-secondary-content');
            document.body.classList.remove('show-secondary-content');
            document.body.classList.add('is-landing-page');
          } else {
            console.log('This is NOT a landing page - keeping show-secondary-content');
          }
        } else {
          console.log('No window._template.suffix found - keeping show-secondary-content');
        }
        
        // Also check body class as secondary check
        if (!isLandingPage && isLandingPageTemplate()) {
          console.log('Body has landing-page class - removing show-secondary-content');
          document.body.classList.remove('show-secondary-content');
          document.body.classList.add('is-landing-page');
        }
        
      } catch (error) {
        console.error('Error in detection, but keeping header visible:', error);
        // Make absolutely sure the class is there on error
        document.body.classList.add('show-secondary-content');
      }
      
      // Final verification
      console.log('FINAL body classes:', document.body.className);
      console.log('Header should be visible:', document.body.classList.contains('show-secondary-content'));
    });
    
    // BACKUP: Also try adding the class after a short delay as a failsafe
    setTimeout(function() {
      if (!document.body.classList.contains('show-secondary-content') && 
          !document.body.classList.contains('is-landing-page')) {
        document.body.classList.add('show-secondary-content');
        console.log('FAILSAFE: Added show-secondary-content after timeout');
      }
    }, 100);
    
    // Export functions to parent scope for quiz management
    window._customHelpers = window._customHelpers || {};
    window._customHelpers.isLandingPageTemplate = isLandingPageTemplate;
    window._customHelpers.isLoadSecondaryContentTemplate = isLoadSecondaryContentTemplate;
  })();


// ============================================
// SECTION: SIZE CHART POP-UP MODAL (CONTROLLER)
// ============================================
function activateSizeChartModal() {
  const modalTrigger = document.querySelector('#size-chart-trigger');
  const modal = document.querySelector('#size-chart-modal');
  
  // If the link or the modal aren't on this page, do nothing.
  if (!modalTrigger || !modal) {
    return;
  }

  const closeButton = modal.querySelector('#sc-modal-close');

  const openModal = (event) => {
    event.preventDefault(); // Stop the link from jumping to the top of the page
    modal.classList.remove('hidden');
    document.body.classList.add('sc-modal-open');
  };

  const closeModal = () => {
    modal.classList.add('hidden');
    document.body.classList.remove('sc-modal-open');
  };

  // --- Attach Event Listeners ---
  modalTrigger.addEventListener('click', openModal);
  closeButton.addEventListener('click', closeModal);
  
  // Close when clicking the dark background
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  // Close with the 'Escape' key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
}

// Run the function after the page has loaded
document.addEventListener('DOMContentLoaded', activateSizeChartModal);

// ============================================
// SECTION 1.2: DISPLAY PRODUCT TITLES FOR MEGA MYSTERY BUNDLE
// ============================================

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Safety check: Exit if the data isn't ready or container is missing
    if (typeof bundledItemsByVariant === 'undefined' || !document.getElementById('bundle-contents-container')) {
      return;
    }

    const bundleContainer = document.getElementById('bundle-contents-container');
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const masterVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;

    if (!bundleContainer || !productForm || !masterVariantInput) {
      return;
    }

    const updateBundleContents = () => {
      const currentVariantId = masterVariantInput.value;
      const items = bundledItemsByVariant[currentVariantId];
      
      if (items && items.length > 0) {
        const cleanedTitlesWithDuplicates = [];
        
        items.forEach(item => {
          let originalTitle = item['product_title'];
          let cleanedTitle = originalTitle.trim();

          // --- CHANGED LOGIC START ---

          // 1. Remove Suffixes (Updated to be more flexible)
          // Matches "No Fly", "V-Fly", "V Fly", OR just a pack count like "4pk"
          const suffixPattern = /\s+(No Fly|V-Fly|V Fly|\d+pk).*$/i;
          cleanedTitle = cleanedTitle.replace(suffixPattern, '');

          // 2. Remove Prefixes (The "Sandwich" Method)
          // Instead of a list of words, we look for the inch measurement (e.g. 7in, 28in)
          // and remove it + everything before it.
          const measurementPattern = /^.*?\d+in\s+/i;
          cleanedTitle = cleanedTitle.replace(measurementPattern, '');

          // 3. Extra Cleanup
          // If no inches were found, ensure "1x" is still removed
          cleanedTitle = cleanedTitle.replace(/^\d+x\s+/i, '');
          
          // 4. Clean up immediate duplicate words (e.g. "Leggings Leggings")
          cleanedTitle = cleanedTitle.replace(/\b(\w+)\s+\1\b/g, '$1');

          // --- CHANGED LOGIC END ---
          
          cleanedTitlesWithDuplicates.push(cleanedTitle);
        });
        
        // 5. Remove duplicate items entirely
        const uniqueTitles = [...new Set(cleanedTitlesWithDuplicates)];

        // 6. Build HTML
        let html = '<div style="font-size: 1em; text-transform: uppercase; margin-bottom: 4px; font-weight: 400;">In This Pack:</div>';
        html += `<p style="margin-top: 0;"><span>&bull; </span>${uniqueTitles.join(', ')}</p>`;
        
        bundleContainer.innerHTML = html;

      } else {
        bundleContainer.innerHTML = '';
      }
    };

    masterVariantInput.addEventListener('change', updateBundleContents);
    updateBundleContents();
  });

})();


// ============================================
// SECTION 1.3: CSE PREORDER VISIBILITY MANAGER
// ============================================

// Helper: Toggles visibility based on the presence of the preorder button
function checkPreorderVisibility(scope) {
  var context = scope || document;
  
  // Look for the specific trigger button
  var preorderBtn = context.querySelector('.restock-rocket-preorder-button');
  
  // Find ALL instances of the cse element in this context
  var allTargets = context.querySelectorAll('.cse-container');

  allTargets.forEach(function(element) {
    if (preorderBtn) {
      // Hide if preorder button is detected
      element.style.display = 'none';
    } else {
      // Reset visibility if preorder button is not there
      element.style.display = ''; 
    }
  });
}

// Helper: Runs the check multiple times to account for App lag
function runSafetyNetChecks(scope) {
  // Check immediately
  checkPreorderVisibility(scope);

  // Check again at 100ms (Standard theme updates)
  setTimeout(function() { checkPreorderVisibility(scope); }, 100);

  // Check at 500ms (Slower Javascript execution)
  setTimeout(function() { checkPreorderVisibility(scope); }, 500);

  // Check at 1500ms (Network/App delays)
  setTimeout(function() { checkPreorderVisibility(scope); }, 1500);
}

// Listener 1: Handle Variant Changes
document.addEventListener('theme:variant:change', function(event) {
  var variant = event.detail.variant;
  var container = event.target;
  
  if (variant) {
    runSafetyNetChecks(container);
  }
});

// Listener 2: Handle Initial Page Load
document.addEventListener('DOMContentLoaded', function() {
  runSafetyNetChecks(document);
});

// ============================================
// SECTION 1.4: UPCART REWARDS VISIBILITY MANAGER
// ============================================

// Helper: Manages visibility of UpCart rewards based on URL parameters
function manageUpCartRewardsVisibility(scope) {
  var context = scope || document;
  
  // 1. Configuration constants
  var targetParam = 'abralink';
  var targetValue = 'Progress-Bar-3';
  var storageKey = 'forceHideUpCartRewards';
  
  // 2. Check current URL for the parameter
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get(targetParam) === targetValue) {
    sessionStorage.setItem(storageKey, 'true');
  }

  // 3. Determine if the element should remain hidden
  var isFlaggedForHiding = sessionStorage.getItem(storageKey) === 'true';
  
  // 4. Find ALL instances of the rewards container
  var rewardTargets = context.querySelectorAll('.upcart-internal-rewards.upcart-public-rewards');

  rewardTargets.forEach(function(element) {
    if (isFlaggedForHiding) {
      // Keep hidden if the parameter was detected in this session
      element.style.setProperty('display', 'none', 'important');
    } else {
      // Unhide for standard organic users (reverting the default CSS)
      element.style.setProperty('display', 'flex', 'important');
    }
  });
}

// Initialization: Watches for UpCart to inject elements and runs the helper
(function() {
  var observer = new MutationObserver(function() {
    manageUpCartRewardsVisibility(document.body);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

  // ============================================
  // SECTION 2: HIDE QUANTITY SELECTOR FOR 'TRYON ITEMS'
  // ============================================

// Hide quantity selector for "try before you buy" items in cart
(function() {
    'use strict';
    
    // The CSS class to add for hiding elements.
    const HIDE_CLASS = 'upcart-hide-quantity';
    
    // Continuous checker for the Upcart drawer and its contents
    let checkInterval = null;
    let checkAttempts = 0;
    const maxAttempts = 30; // 1.5 seconds at 50ms interval

    function hideQuantityForTryBeforeYouBuy() {
        // Find all product items in the cart drawer.
        const productItems = document.querySelectorAll('.upcart-product-item');

        if (productItems.length > 0) {
            // If we find the items, stop the continuous check and proceed.
            if (checkInterval) {
                clearInterval(checkInterval);
            }
            console.log(`Found ${productItems.length} product items. Checking each for "try before you buy" text.`);

            productItems.forEach((item) => {
                // Check if the current product item contains the "try before you buy" text.
                if (item.textContent && item.textContent.toLowerCase().includes('try before you buy')) {
                    console.log('Found "try before you buy" text in a product item. Hiding its quantity selector...');

                    // Now, find the specific Stack__item that contains the quantity selector within this item.
                    const quantityStackItem = item.querySelector('.styles_ProductRow__stepper__');
                    
                    if (quantityStackItem) {
                        console.log('Found the quantity selector stepper. Hiding it.');
                        quantityStackItem.classList.add(HIDE_CLASS);
                    } else {
                        console.log('Could not find the quantity selector stepper within the product item.');
                    }
                }
            });
        } else {
            // Log a message if no product items are found. The continuous check will continue.
            console.log('No product items found in the Upcart popup.');
        }
    }

    // --- Observer and Initialization Logic ---
    function setupUpcartPopupObserver() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    
                    if (target === document.body && 
                        target.classList.contains('upcartPopupShow')) {
                        
                        console.log('Upcart popup opened, starting continuous check...');
                        
                        // Start the continuous check for the product items
                        checkInterval = setInterval(() => {
                            if (checkAttempts >= maxAttempts) {
                                clearInterval(checkInterval);
                                console.log('FAILURE: Max attempts reached. Could not find product items.');
                                return;
                            }
                            hideQuantityForTryBeforeYouBuy();
                            checkAttempts++;
                        }, 50); // Check every 50ms
                    }
                }
            });
        });
        
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });
        console.log('Upcart popup observer set up - watching for body.upcartPopupShow class');
        
        if (document.body.classList.contains('upcartPopupShow')) {
            console.log('Upcart popup already open on page load, starting continuous check...');
            checkInterval = setInterval(() => {
                if (checkAttempts >= maxAttempts) {
                    clearInterval(checkInterval);
                    console.log('FAILURE: Max attempts reached. Could not find product items.');
                    return;
                }
                hideQuantityForTryBeforeYouBuy();
                checkAttempts++;
            }, 50);
        }
    }
    
    function init() {
        console.log('Initializing cart quantity hider script...');
        setupUpcartPopupObserver();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

  // ============================================
  // SECTION 3: STICKY ADD TO CART BUTTON
  // ============================================
  (function() {
    // Configuration Variables
    const stickyButtonSelector = '#upCartStickyButton > div';
    const cartContentSelector = 'span.header__cart__status';
    const scrollThreshold = 200;

    // Element References
    let stickyButton = null;
    let cartContentElement = null;

    // Retry Configuration
    const maxRetries = 10;
    const retryDelayMs = 100;
    let currentRetries = 0;

    function hasCartItems() {
      if (!cartContentElement) {
        return false;
      }

      // Check for data-header-cart-count attribute
      const cartCountSpan = cartContentElement.querySelector('span[data-header-cart-count]');
      if (cartCountSpan) {
        const cartCountAttr = cartCountSpan.getAttribute('data-header-cart-count');
        if (cartCountAttr) {
          const itemCount = parseInt(cartCountAttr, 10);
          if (!isNaN(itemCount) && itemCount > 0) {
            return true;
          }
        }
      }

      // Check for data-header-cart-full attribute
      const cartFullSpan = cartContentElement.querySelector('span[data-header-cart-full]');
      if (cartFullSpan) {
        const cartFullAttr = cartFullSpan.getAttribute('data-header-cart-full');
        if (cartFullAttr === 'true') {
          return true;
        }
      }

      return false;
    }

    function toggleStickyButtonVisibility() {
      if (!stickyButton) {
        return;
      }
      const scrolledEnough = window.scrollY >= scrollThreshold;
      const itemsInCart = hasCartItems();

      if (scrolledEnough && itemsInCart) {
        stickyButton.classList.add('is-visible');
        stickyButton.classList.remove('is-hidden');
      } else {
        stickyButton.classList.add('is-hidden');
        stickyButton.classList.remove('is-visible');
      }
    }

    function initializeSimplifiedStickyButton() {
      stickyButton = document.querySelector(stickyButtonSelector);
      cartContentElement = document.querySelector(cartContentSelector);

      if (stickyButton && cartContentElement) {
        // Initial check on page load
        toggleStickyButtonVisibility();
        window.addEventListener('scroll', toggleStickyButtonVisibility);

        // Setup MutationObserver for cartContentElement
        const observerConfig = {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        };
        const observer = new MutationObserver(function(mutationsList, observer) {
          toggleStickyButtonVisibility();
        });
        observer.observe(cartContentElement, observerConfig);
      } else {
        currentRetries++;
        if (currentRetries < maxRetries) {
          console.warn(`Sticky button elements not found on attempt ${currentRetries}. Retrying...`);
          setTimeout(initializeSimplifiedStickyButton, retryDelayMs);
        } else {
          console.error(`Required elements (stickyButton or cartContentElement) not found after ${maxRetries} retries.`);
        }
      }
    }

    document.addEventListener('DOMContentLoaded', initializeSimplifiedStickyButton);
  })();

  // ============================================
  // SECTION 4: THEME VARIANT CHANGE LISTENER
  // ============================================
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

 // ============================================
 // SECTION 5: QUIZ POPUP MANAGEMENT (MODIFIED)
 // ============================================
 (function() {
   function manageQuizPopups() {
     // Use helper functions from window._customHelpers
     if (!window._customHelpers) {
       console.warn('Custom helpers not loaded yet for quiz management');
       return;
     }
     
     const isLandingPageTemplate = window._customHelpers.isLandingPageTemplate;
     const isLoadSecondaryContentTemplate = window._customHelpers.isLoadSecondaryContentTemplate;
     
     const quizToHideSelector = '#open-quiz-tools\\/perfect-product-finder\\/simple-fit-quiz-discount-offer';

     // *** NEW LOGIC STARTS HERE ***

     // 1. Define the specific URL paths where the quiz should be hidden.
     //    Use the path part of the URL (e.g., '/pages/about-us', '/collections/sale').
     //    The check is done using startsWith(), so '/collections/sale' will match all pages in that collection.
     const pathsToHideQuizOn = [
       '/pages/embeded-sign-up',
       // Add more paths as needed
     ];

     // 2. Helper function to check if the current page path is in the exclusion list
     function isPathToHideQuiz() {
       const currentPath = window.location.pathname.toLowerCase();
       return pathsToHideQuizOn.some(path => currentPath.startsWith(path.toLowerCase()));
     }

     // 3. Update the conditional check
     if (isLandingPageTemplate() || isPathToHideQuiz()) {
       // *** LOGIC FOR HIDING THE QUIZ ***
       console.log('Landing page or exclusion path detected. Hiding unwanted quiz...');

       const hideQuiz = (element) => {
         if (element) {
           element.style.display = 'none';
           element.style.pointerEvents = 'none';
           element.setAttribute('data-hidden-by-script', 'true');
           console.log('Hidden quiz:', quizToHideSelector);
         }
       };

       // Initial check
       let quizToHide = document.querySelector(quizToHideSelector);
       hideQuiz(quizToHide);

       // Set up MutationObserver to hide quiz if it loads dynamically later
       const observerConfig = { childList: true, subtree: true };
       const observerCallback = function(mutationsList, observer) {
         for (let mutation of mutationsList) {
           if (mutation.type === 'childList') {
             mutation.addedNodes.forEach(node => {
               if (node.nodeType === 1) {
                 const addedQuizToHide = node.matches && node.matches(quizToHideSelector) ? 
                   node : (node.querySelector ? node.querySelector(quizToHideSelector) : null);
                 if (addedQuizToHide && !addedQuizToHide.hasAttribute('data-hidden-by-script')) {
                   hideQuiz(addedQuizToHide);
                   console.log('Hidden quiz (via MutationObserver):', quizToHideSelector);
                 }
               }
             });
           }
         }
       };

       const observer = new MutationObserver(observerCallback);
       observer.observe(document.body, observerConfig);

     // *** END OF HIDING LOGIC ***

     } else if (isLoadSecondaryContentTemplate()) {
       console.log("'load-secondary-content' detected. All quizzes will display as usual.");
     } else {
       console.log('Neither "landing-page", exclusion path, nor "load-secondary-content" detected. Default quiz behavior.');
     }
   }

   // Run only once when DOM is ready
   document.addEventListener('DOMContentLoaded', manageQuizPopups);
   // Additional load event for dynamically loaded content
   window.addEventListener('load', manageQuizPopups);
 })();

 // ============================================
 // SECTION 6: LOOX BRANDING HIDE
 // ============================================
 document.addEventListener('DOMContentLoaded', function() {
   setTimeout(function() {
     const looxBranding = document.querySelector('.loox-branding');
     if (looxBranding) {
       looxBranding.style.display = 'none';
     }
   }, 500);
 });

  // ============================================
  // SECTION 7: THEME EVENT LISTENERS (DEBUGGING)
  // ============================================
  // Comment these out in production to reduce console noise
  /*
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });
  */

  // ============================================
  // SECTION 8: AFFILIATE DETECTION & POPUP SUPPRESSION
  // ============================================
  (function() {
    // Define your affiliate parameters
    const AFFILIATE_PARAMS = ['snowball'];

    // Function to check if current URL has affiliate parameters
    function isAffiliateTraffic() {
      const urlParams = new URLSearchParams(window.location.search);
      
      for (let param of AFFILIATE_PARAMS) {
        if (urlParams.has(param)) {
          const paramValue = urlParams.get(param);
          console.log('Affiliate traffic detected via parameter:', param + '=' + paramValue);
          return true;
        }
      }
      return false;
    }

    // Function to set affiliate session flag
    function setAffiliateFlag() {
      try {
        sessionStorage.setItem('affiliate_visitor', 'true');
        document.cookie = "affiliate_session=true; path=/; SameSite=Lax";
        console.log('Affiliate session flag set');
      } catch (e) {
        console.error('Error setting affiliate flag:', e);
      }
    }

    // Main detection logic
    function detectAffiliateTraffic() {
      if (!sessionStorage.getItem('affiliate_visitor') && isAffiliateTraffic()) {
        setAffiliateFlag();
      }
    }

    // Function to check if visitor is from affiliate
    function isAffiliateVisitor() {
      try {
        if (sessionStorage.getItem('affiliate_visitor') === 'true') {
          return true;
        }
        
        if (document.cookie.includes('affiliate_session=true')) {
          return true;
        }
        
        return false;
      } catch (e) {
        console.error('Error checking affiliate status:', e);
        return false;
      }
    }

    // Function to determine if popup should be shown
    function shouldShowDiscountPopup() {
      if (isAffiliateVisitor()) {
        console.log('Popup suppressed for affiliate visitor');
        return false;
      }
      return true;
    }

    // Hide Postscript elements with CSS for affiliate visitors
    function suppressPostscriptForAffiliates() {
      if (isAffiliateVisitor()) {
        const style = document.createElement('style');
        style.textContent = `
          #ps__widget_container,
          #ps__widget,
          iframe[src*="postscript.io"],
          [data-ps-popup-status] {
            display: none !important;
            visibility: hidden !important;
          }
        `;
        document.head.appendChild(style);
        console.log('Postscript widgets suppressed for affiliate visitor');
      }
    }

    // Monitor for Postscript elements and hide them dynamically
    function watchForPostscriptElements() {
      if (!isAffiliateVisitor()) return;
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.id === 'ps__widget_container' || 
                  node.id === 'ps__widget' ||
                  (node.matches && node.matches('[data-ps-popup-status]'))) {
                node.style.display = 'none';
                node.style.visibility = 'hidden';
                console.log('Postscript element intercepted and hidden:', node.id || node.className);
              }
              
              if (node.querySelectorAll) {
                const postscriptElements = node.querySelectorAll(`
                  #ps__widget_container,
                  #ps__widget,
                  [data-ps-popup-status],
                  iframe[src*="postscript.io"]
                `);
                
                postscriptElements.forEach(function(element) {
                  element.style.display = 'none';
                  element.style.visibility = 'hidden';
                  console.log('Postscript child element intercepted and hidden');
                });
              }
            }
          });
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      console.log('Postscript element watcher activated');
    }

    // Remove existing Postscript elements if they're already on the page
    function removeExistingPostscriptElements() {
      if (!isAffiliateVisitor()) return;
      
      const existingElements = document.querySelectorAll(`
        #ps__widget_container,
        #ps__widget,
        [data-ps-popup-status],
        iframe[src*="postscript.io"]
      `);
      
      existingElements.forEach(function(element) {
        element.remove();
        console.log('Existing Postscript element removed');
      });
    }

    // Main initialization function for Postscript suppression
    function initPostscriptSuppression() {
      if (isAffiliateVisitor()) {
        console.log('Initializing Postscript suppression for affiliate visitor');
        
        suppressPostscriptForAffiliates();
        watchForPostscriptElements();
        removeExistingPostscriptElements();
        
        setTimeout(removeExistingPostscriptElements, 1000);
        setTimeout(removeExistingPostscriptElements, 3000);
        setTimeout(removeExistingPostscriptElements, 5000);
      }
    }

    // Debug function (remove in production)
    window.debugAffiliateStatus = function() {
      console.log('=== AFFILIATE DEBUG INFO ===');
      console.log('Current URL:', window.location.href);
      console.log('URL Parameters:', window.location.search);
      console.log('Session Storage Flag:', sessionStorage.getItem('affiliate_visitor'));
      console.log('Cookie Check:', document.cookie.includes('affiliate_session=true'));
      console.log('Is Affiliate Visitor:', isAffiliateVisitor());
      console.log('Should Show Popup:', shouldShowDiscountPopup());
      console.log('=== END DEBUG INFO ===');
    };

    // Initialize everything
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        detectAffiliateTraffic();
        initPostscriptSuppression();
      });
    } else {
      detectAffiliateTraffic();
      initPostscriptSuppression();
    }

    // Also run with delays to catch late-loading scenarios
    setTimeout(initPostscriptSuppression, 1000);
    setTimeout(initPostscriptSuppression, 3000);
  })();


  /* This code has been problematic. What I'm trying to do is get the postscript pop-up to not display while people are taking the quiz. 
  Right now I'm just going to implement a timing of the pop-up fix. Hopefully if I change the timing of when things display, that will get us 80% of the way there 
  // ============================================
  // SECTION 9: POPUP CONFLICT SUPPRESSION
  // ============================================
  (function() {
    // Function to manage visibility between Quiz and Postscript
      function managePopupConflict() {
      // 1. Look for the iframe-holder inside the PPF popup
      const iframeHolder = document.querySelector('.ppf-popup .iframe-holder');
      const postscriptContainer = document.querySelector('#ps__widget_container');

      if (!postscriptContainer) {
        return;
      }

      // Check if the iframe-holder is currently active AND visually open
      let isQuizOpen = false;

      // 2. If the iframe-holder actually exists in the code right now...
      if (iframeHolder) {
        const holderStyles = window.getComputedStyle(iframeHolder);
        
        // 3. ...check if the browser is currently rendering it on screen
        isQuizOpen = (
          holderStyles.display !== 'none' && 
          holderStyles.opacity !== '0' && 
          holderStyles.visibility !== 'hidden' &&
          iframeHolder.offsetHeight > 0
        );
      }

      if (isQuizOpen) {
        // Send to back, make transparent, and remove clickability
        postscriptContainer.style.setProperty('z-index', '-9999', 'important');
        postscriptContainer.style.setProperty('opacity', '0', 'important');
        postscriptContainer.style.setProperty('pointer-events', 'none', 'important');
        console.log('Postscript suppressed (Z-Index): Fit Quiz is active');
      } else {
        // Restore standard behavior
        postscriptContainer.style.removeProperty('z-index');
        postscriptContainer.style.removeProperty('opacity');
        postscriptContainer.style.removeProperty('pointer-events');
      }
    }

    // Observe DOM changes to trigger suppression immediately
    const popupObserver = new MutationObserver(function(mutations) {
      managePopupConflict();
    });

    try {
      popupObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) {
      console.error('Error initializing Popup Observer:', e);
    }
  })();
*/
})(); // End main IIFE